export const columnsSummary = [
    { header: "", accessor: "name", className: "transfer-prepak__table--col1" },
    { header: "Fit", accessor: "amountFit", bold: false, className: "transfer-prepak__table--col2" },
    { header: "New", accessor: "amountNew", bold: false, className: "transfer-prepak__table--col3" },
    { header: "Processed", accessor: "amountProcessed", bold: false, className: "transfer-prepak__table--col4" },
    { header: "Total", accessor: "total", bold: false },
]
export const categories = [{ name: "fit" }, { name: "new" }, { name: "processed" }]
